import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { List, ListItem } from '@mui/material';
import { KundenDokument } from '@codefluegel/wowis-rest-typescript-client';
import moment from 'moment';
import CardContainer from '../cards/CardContainer';
import DocumentListItem from './DokumentListItem';
import useMedia from '../../hooks/useMedia';
import useDocuments from '../../hooks/useDocuments';

interface Props {
  documents: KundenDokument[] | null | undefined;
}

const DocumentsList: FC<Props> = observer(props => {
  const { documents } = props;
  const isMobile = useMedia('md');

  const documentApi = useDocuments();

  return (
    <CardContainer
      title="Dokumente: Mitteilungen"
      customStyle={{
        sx: { margin: isMobile ? 0 : '20px', marginTop: isMobile ? 3 : 0 },
      }}
    >
      <List
        sx={{
          display: 'flex',
          flexDirection: 'column',
          pb: 3,
          width: '100%',
          marginTop: -2,
        }}
      >
        {documents
          ?.sort(
            (a, b) => moment(a.datum).valueOf() - moment(b.datum).valueOf(),
          )
          .reverse()
          .map(document => (
            <ListItem key={document.token}>
              <DocumentListItem
                document={document}
                onDocumentClick={() => documentApi.downloadDocument(document)}
                textColor="#58585A"
              />
            </ListItem>
          ))}
      </List>
    </CardContainer>
  );
});

export default DocumentsList;
